import { render, staticRenderFns } from "./form-user-permissions-coder-home.vue?vue&type=template&id=40640798&scoped=true"
import script from "./form-user-permissions-coder-home.vue?vue&type=script&lang=js"
export * from "./form-user-permissions-coder-home.vue?vue&type=script&lang=js"
import style0 from "./form-user-permissions-coder-home.vue?vue&type=style&index=0&id=40640798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40640798",
  null
  
)

export default component.exports